<script setup>
import {changeStep, Steps} from "@/composables/ai-onboarding/useSteps";
import JobProcessingProgress from "@/components/ai-processing/JobProcessingProgress.vue";

const emit = defineEmits(['changeStep']);

const emitNextStep = async () => {
  changeStep(Steps.KEYWORDS, emit);
}

const stepSummaryConfig = {
  1: {
    text: "Understanding what people are searching for",
    svg: 'illustrations/ai-onboarding-image-1'
  },
  2: {
      text: "Checking the locations you want to reach",
      svg: 'illustrations/ai-onboarding-image-2'
    },
  3: {
      text: "Discovering the best keywords for your products and services",
      svg: 'illustrations/ai-onboarding-image-3'
    },
  4: {
    text: "Ensuring the keywords are closely related to your business",
    svg: 'illustrations/ai-onboarding-image-4'
  },
  5: {
    text: "Refining thousands of keywords to find the best for your SEO campaign",
    svg: 'illustrations/ai-onboarding-image-5'
  },
  6: {
    text: "Summarising our selection",
    svg: 'illustrations/ai-onboarding-image-6'
  },
}

</script>

<template>
  <JobProcessingProgress
    :ai-summary-url-path="Steps.HOLDING.aiSummaryUrlPath"
    data-url-path="/ajax/v2/ai-onboarding/job-status"
    :step-summary-config="stepSummaryConfig"
    :ai-sitemap="false"
    hide-percentage
    @trigger-navigation-event="emitNextStep"
  />
</template>
